import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { FarmoutService } from 'src/app/service/farmout-service/farmout.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment-timezone';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { CsvService } from 'src/app/service/csv-service/csv.service';

@Component({
  selector: 'app-farmout-savings',
  templateUrl: './farmout-savings.component.html',
  styleUrls: ['./farmout-savings.component.css']
})
export class FarmoutSavingsComponent implements OnInit, OnDestroy {
  user: any;
  timeZone: string = '';
  todayDate: any;
  search: string = '';
  savingsList: any[] = [];
  savingStats: any;

  constructor(
    private farmoutService: FarmoutService,
    private sharedDataService: SharedDataService,
    private toastr: ToastrService,
    private csvService: CsvService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.user = data;
          this.timeZone = data.timeZone;
          this.todayDate = [
            moment.tz(this.timeZone).startOf('day').toISOString(),
            moment.tz(this.timeZone).endOf('day').toISOString(),
          ];
          this.loadData();
        }
      });
  }

  loadData() {
    this.getFarmoutSavings();
    this.getFarmoutSavingStats();
  }

  getFarmoutSavings() {
    const queryParams: any = {};
    if (this.todayDate && this.todayDate.length === 2 && this.todayDate[0] && this.todayDate[1]) {
      queryParams.start = this.todayDate[0];
      queryParams.end = this.todayDate[1];
    }
    this.farmoutService.getFarmoutSavings(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data: any) => {
        if (data && data.farmoutsavings) {
          this.savingsList = data.farmoutsavings;
        } else {
          this.savingsList = [];
        }
      }, (err) => {
      });
  }

  getFarmoutSavingStats() {
    const payload: any = {};
    if (this.todayDate && this.todayDate.length === 2 && this.todayDate[0] && this.todayDate[1]) {
      payload.startDate = this.todayDate[0];
      payload.endDate = this.todayDate[1];
    }
    this.farmoutService.getFarmoutSavingStats(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data: any) => {
        if (data && data.stats) {
          this.savingStats = data.stats;
        }
      }, (err) => {
      });
  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0].toISOString(),
      event[1].endOf('day').toISOString(),
    ];
    this.loadData();
  }

  downloadReport() {
    this.csvService.downloadFarmoutSavingsReport({
      savings: this.savingsList,
      date: this.todayDate,
      timezone: this.timeZone
    });
  }

  ngOnDestroy(): void { }
}

